import { BaseChannel } from "@/api/ws/channels/BaseChannel";

export class BorrowerPrivateChannel extends BaseChannel {
  name = "borrower_platform.borrowers";
  isPrivate = true;
}
